export const enum DropdownListTypeEnum {
  danger = 'danger',
  warning = 'warning',
  info = 'info',
  success = 'success',
  secondary = 'secondary',
  light = 'light',
  primary = 'primary',
}
